var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form-item', {
    attrs: {
      "label": _vm.i18nt('designer.setting.displayType')
    }
  }, [_c('el-select', {
    model: {
      value: (_vm.optionModel.type),
      callback: function($$v) {
        _vm.$set(_vm.optionModel, "type", $$v)
      },
      expression: "optionModel.type"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "default",
      "value": ""
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "primary",
      "value": "primary"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "success",
      "value": "success"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "warning",
      "value": "warning"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "danger",
      "value": "danger"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "info",
      "value": "info"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "text",
      "value": "text"
    }
  })], 1)], 1)
}
var staticRenderFns = []
export default { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-83edcdf6","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/form-designer/setting-panel/property-editor/field-button/button-type-editor.vue
// module id = null
// module chunks = 